import { ITranslations } from "../domain/types";

// Keep client-side errors available even when the API's translation catalog
// has not yet been updated. API translations take precedence when present.
const english = {
  THIS_FIELD_IS_REQUIRED: "This field is required",
  VALIDATION_FORMAT: "Please ensure this field is formatted correctly.",
  VALIDATION_EMAIL: "Please enter a valid email address",
  VALIDATION_MIN_LENGTH: "Please enter the minimum required characters.",
  VALIDATION_PHONE_MIN_LENGTH: "Please enter at least 7 characters",
  VALIDATION_NUMBERS_ONLY: "Only numbers are allowed",
  VALIDATION_CHARACTER_LIMIT: "Characters limit for this input was reached.",
  VALIDATION_COMPANY_NAME: "Company Name is required when First Name and Last Name are not provided",
  VALIDATION_REQUIRED_FIELDS: "Please make sure all required fields are filled in",
  VALIDATION_DONATION_AMOUNT: "Please enter Donation Amount",
  VALIDATION_DONOR_NAME: "Please provide a Company Name, or both First Name and Last Name",
  VALIDATION_ROUTING_NUMBER: "Please ensure the routing number is formatted correctly.",
  VALIDATION_ACCOUNT_NUMBER: "Please ensure the account number is formatted correctly.",
  VALIDATION_STORY_CREDIT_CARD: "Please do not include credit card information in your story",
  VALIDATION_COMMENTS_CREDIT_CARD: "Please do not include credit card information in your comments",
  VALIDATION_ZIP_REQUIRED: "A zip code is required",
  VALIDATION_ZIP_FORMAT: "Please enter a valid zip code",
  ZIP_CODE_NOT_FOUND: "The Zip code entered was not found",
  HOSPITAL_SEARCH_NOT_FOUND: "Sorry, we didn't find a hospital for that search. Please try again.",
  PAYMENT_METHOD_HEADING: "Payment method",
  PAYMENT_METHOD_ERROR: "We could not load this payment method. Please try again or select another payment method.",
  PAYMENT_METHOD_VERIFY: "We could not verify your payment information. Please check your details and try again.",
  PAYMENT_METHOD_REQUIRED: "Please select a payment method",
  PAYMENT_METHOD_UNSUPPORTED: "This payment method is not supported. Please select a different payment method.",
  BANK_DETAILS_ERROR: "We could not verify your bank details. Please check your information and try again.",
  BANK_NAME_NOT_FOUND: "We could not find a bank for that routing number. Please check the number and enter the bank name.",
  ERROR_LOAD_DONATION_FORM: "We could not load the donation form. Please refresh the page and try again.",
  ERROR_INVALID_DONATION_LINK: "This donation link is invalid. Please check the link and try again.",
  ERROR_RECAPTCHA: "We could not complete the security check. Please try again.",
  ERROR_GENERIC: "Something went wrong. Please try again.",
};

const spanish: Record<keyof typeof english, string> = {
  THIS_FIELD_IS_REQUIRED: "Este campo es obligatorio",
  VALIDATION_FORMAT: "Asegúrese de que este campo tenga el formato correcto.",
  VALIDATION_EMAIL: "Ingrese una dirección de correo electrónico válida",
  VALIDATION_MIN_LENGTH: "Ingrese al menos la cantidad mínima de caracteres requerida.",
  VALIDATION_PHONE_MIN_LENGTH: "Ingrese al menos 7 caracteres",
  VALIDATION_NUMBERS_ONLY: "Solo se permiten números",
  VALIDATION_CHARACTER_LIMIT: "Se ha alcanzado el límite de caracteres para este campo.",
  VALIDATION_COMPANY_NAME: "El nombre de la compañía es obligatorio si no se proporcionan el nombre y el apellido",
  VALIDATION_REQUIRED_FIELDS: "Asegúrese de completar todos los campos obligatorios",
  VALIDATION_DONATION_AMOUNT: "Ingrese el monto de la donación",
  VALIDATION_DONOR_NAME: "Ingrese el nombre de la compañía o su nombre y apellido",
  VALIDATION_ROUTING_NUMBER: "Asegúrese de que el número de ruta bancaria tenga el formato correcto.",
  VALIDATION_ACCOUNT_NUMBER: "Asegúrese de que el número de cuenta tenga el formato correcto.",
  VALIDATION_STORY_CREDIT_CARD: "No incluya información de tarjetas de crédito en su historia",
  VALIDATION_COMMENTS_CREDIT_CARD: "No incluya información de tarjetas de crédito en sus comentarios",
  VALIDATION_ZIP_REQUIRED: "El código postal es obligatorio",
  VALIDATION_ZIP_FORMAT: "Ingrese un código postal válido",
  ZIP_CODE_NOT_FOUND: "No se encontró el código postal ingresado",
  HOSPITAL_SEARCH_NOT_FOUND: "Lo sentimos, no encontramos un hospital con esa búsqueda. Inténtelo de nuevo.",
  PAYMENT_METHOD_HEADING: "Método de pago",
  PAYMENT_METHOD_ERROR: "No se pudo cargar este método de pago. Inténtelo de nuevo o seleccione otro método de pago.",
  PAYMENT_METHOD_VERIFY: "No se pudo verificar su información de pago. Revise los datos e inténtelo de nuevo.",
  PAYMENT_METHOD_REQUIRED: "Seleccione un método de pago",
  PAYMENT_METHOD_UNSUPPORTED: "Este método de pago no es compatible. Seleccione otro método de pago.",
  BANK_DETAILS_ERROR: "No se pudieron verificar sus datos bancarios. Revise la información e inténtelo de nuevo.",
  BANK_NAME_NOT_FOUND: "No se encontró un banco con ese número de ruta bancaria. Revise el número e ingrese el nombre del banco.",
  ERROR_LOAD_DONATION_FORM: "No se pudo cargar el formulario de donación. Actualice la página e inténtelo de nuevo.",
  ERROR_INVALID_DONATION_LINK: "Este enlace de donación no es válido. Revise el enlace e inténtelo de nuevo.",
  ERROR_RECAPTCHA: "No se pudo completar la verificación de seguridad. Inténtelo de nuevo.",
  ERROR_GENERIC: "Se produjo un error. Inténtelo de nuevo.",
};

export const errorTranslations: Record<string, ITranslations> = {
  "en-US": english,
  "es-US": spanish,
};
